import './StudentInfo.scss'

import { ExclamationCircleFilled } from '@ant-design/icons'
import { Col, Form, Input, Radio, RadioChangeEvent, Row } from 'antd'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { Sepet } from '../../gql/GeneratedGraphqlTypes'
import { KIRTASIYE_KATEGRI_ID } from '../../utils/const'
import { ReactComponent as UserIcon } from './images/erkek.svg'
import { ReactComponent as UserFemaleIcon } from './images/Kiz.svg'
import { ReactComponent as StudentIcon } from './images/student.svg'
interface Props {
  data: Sepet
  setIsBasketTableVisible: React.Dispatch<React.SetStateAction<boolean>>
  setIsBasketDeleteVisible: React.Dispatch<React.SetStateAction<boolean>>
  setIsDigital: React.Dispatch<React.SetStateAction<boolean>>
  setIsKirtasiye: React.Dispatch<React.SetStateAction<boolean>>
  studentInfo: {
    studentName: string
    studentSurname: string
    digital: string
    gender: number
  }
  setStudentInfo: Dispatch<
    SetStateAction<{
      studentName: string
      studentSurname: string
      digital: string
      gender: number
    }>
  >
  fieldErrors?: {
    studentName?: string
    studentSurname?: string
    digital?: string
    gender?: string
  }
  setFieldErrors?: Dispatch<SetStateAction<{
    studentName?: string
    studentSurname?: string
    digital?: string
    gender?: string
  }>>
}

const StudentInfo = ({
  data,
  setIsBasketTableVisible,
  setIsBasketDeleteVisible,
  setIsDigital,
  setIsKirtasiye,
  studentInfo,
  setStudentInfo,
  fieldErrors = {},
  setFieldErrors,
}: Props) => {
  const [value, setValue] = useState<number>(0)
  const [documentType, setDocumentType] = useState<'tc' | 'passport'>('tc')
  const [isDigital] = useState(() => {
    if (data && data.urunler) {
      return data.urunler.some(
        (item: any) =>
          item.urun.bilgiler && item.urun.bilgiler.some((bilgi: any) => bilgi.isim === 'TC Gerektiren Ürün'),
      )
    }
    return false
  })

  const [isKirtasiye] = useState(() => {
    if (data && data.urunler) {
      return data.urunler.some((item: any) => {
        if (item?.urun?.kategori) {
          if (
            item.urun.kategori.id === KIRTASIYE_KATEGRI_ID ||
            item.urun.kategori.ust_kategori_id === KIRTASIYE_KATEGRI_ID
          ) {
            return true
          }
        }
        return false
      })
    }
    return false
  })

  useEffect(() => {
    setIsDigital(isDigital)
    setIsKirtasiye(isKirtasiye)
  }, [isDigital, isKirtasiye, setIsDigital, setIsKirtasiye])

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value)
    setStudentInfo({
      ...studentInfo,
      gender: e.target.value,
    })
  }

  const clearError = (field: keyof typeof fieldErrors) => {
    if (setFieldErrors && fieldErrors[field]) {
      setFieldErrors((prev) => ({ ...prev, [field]: undefined }))
    }
  }

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('studentName')
    setStudentInfo({ ...studentInfo, studentName: e.target.value })
  }
  const handleSurnameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('studentSurname')
    setStudentInfo({ ...studentInfo, studentSurname: e.target.value })
  }
  const handleDigitalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('digital')
    setStudentInfo({ ...studentInfo, digital: e.target.value })
  }

  const handleDocumentTypeChange = (e: RadioChangeEvent) => {
    clearError('digital')
    setDocumentType(e.target.value)
    setStudentInfo({ ...studentInfo, digital: '' })
  }

  if (!data) {
    return null
  }

  return (
    <div className="info-card-container">
      <div className="header">
        <div className="header-title">
          <StudentIcon />
          Öğrenci Bilgileri
        </div>
        <p>{data.sinif?.isim}</p>
      </div>
      <Form className="student-info-form" layout="vertical">
        <Row gutter={24} className="student-info">
          <Col xs={24} md={12}>
            <Form.Item
              label="Öğrenci Adı"
              name="studentName"
              validateStatus={fieldErrors.studentName ? 'error' : ''}
              help={fieldErrors.studentName}
            >
              <Input
                value={studentInfo.studentName}
                defaultValue={studentInfo.studentName}
                onChange={handleNameChange}
              />
            </Form.Item>
            {isKirtasiye && (
              <Form.Item
                label="Cinsiyet"
                validateStatus={fieldErrors.gender ? 'error' : ''}
                help={fieldErrors.gender}
              >
                <Radio.Group onChange={(e) => { clearError('gender'); onChange(e) }} value={value} defaultValue={null}>
                  <Radio value={1}>
                    <div className="radio-section">
                      <UserIcon />
                      Erkek
                    </div>
                  </Radio>
                  <Radio value={2}>
                    <div className="radio-section">
                      <UserFemaleIcon />
                      Kız
                    </div>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            )}
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Öğrenci Soyadı"
              name="studentSurname"
              validateStatus={fieldErrors.studentSurname ? 'error' : ''}
              help={fieldErrors.studentSurname}
            >
              <Input
                value={studentInfo.studentSurname}
                defaultValue={studentInfo.studentSurname}
                onChange={handleSurnameChange}
              />
            </Form.Item>
            {isDigital && (
              <>
                <Form.Item label="Kimlik Tipi">
                  <Radio.Group
                    onChange={handleDocumentTypeChange}
                    value={documentType}
                    className="document-type-selector"
                  >
                    <Radio.Button value="tc">T.C. Kimlik No</Radio.Button>
                    <Radio.Button value="passport">Pasaport No</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name="digital"
                  validateStatus={fieldErrors.digital ? 'error' : ''}
                  help={fieldErrors.digital}
                >
                  <Input
                    value={studentInfo.digital}
                    defaultValue={studentInfo.digital}
                    onChange={handleDigitalChange}
                    maxLength={documentType === 'tc' ? 11 : 9}
                    placeholder={documentType === 'tc' ? '11 haneli T.C. Kimlik No' : 'Pasaport Numarası'}
                  />
                </Form.Item>
              </>
            )}
          </Col>
        </Row>
        <div className="info-text">
          <ExclamationCircleFilled />
          <p>
            Eğitim yılı boyunca öğrencimizin dijital ürünlerin kullanımında kullanıcı sorunu yaşamaması için adının,
            soyadının ve sistem sizden talep ediyorsa T.C. kimlik numarasının sipariş esnasında eksiksiz girilmesi gerekmektedir.
          </p>
        </div>
      </Form>
    </div>
  )
}

export default StudentInfo
